import type { ActionContext } from 'vuex'

import type { ActionClass, IndexJobDTO, IndexState } from '../../../models'
import type { IndexJobService, IndexJobServiceJobParams } from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

export class ReimportJobAction implements ActionClass {
  static async execute(
    this: void,
    context: ActionContext<IndexState, unknown>,
    params: IndexJobServiceJobParams,
  ): Promise<IndexJobDTO> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    return service.reimport(params)
  }
}
